import { PropertyService } from './property.service';

export const services = [
  PropertyService,
];
